

































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";

@Component
export default class LogFrameComponent extends Vue {
  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  logKey: number = 0;
  goals: any = [];

  $refs = {};

  mounted() {
    // this.$services.logframework.getGoals().then((goals) => {
    //     this.goals = goals;
    // });
  }

  /** Add result */
  addResult() {
    let id = utils.generateGUID();
    const deliverables = [];
    this.appData.logframework.push({ id, deliverables });
    this.logKey = this.logKey + 1;
    setTimeout(() => {
      if ((this.$refs[id], this.$refs[id][0])) {
        (this.$refs[id][0] as HTMLFormElement).focus();
      }
    }, 100);
    this.$emit("change", true);
  }

  /** Add deliverables */
  addDeliverables(wrapper) {
    let id = utils.generateGUID();
    const activities = [];
    wrapper.deliverables.push({ id, activities });
    this.logKey = this.logKey + 1;
    setTimeout(() => {
      if ((this.$refs[id], this.$refs[id][0])) {
        (this.$refs[id][0] as HTMLFormElement).focus();
      }
    }, 100);
    this.$emit("change", true);
  }

  /** Add activities */
  addActivites(wrapper) {
    let id = utils.generateGUID();
    wrapper.activities.push({ id });
    this.logKey = this.logKey + 1;
    setTimeout(() => {
      if ((this.$refs[id], this.$refs[id][0])) {
        (this.$refs[id][0] as HTMLFormElement).focus();
      }
    }, 100);
    this.$emit("change", true);
  }

  /** delete record */
  deleteRecord(wrapper, item) {
    const index = wrapper.indexOf(item);
    wrapper.splice(index, 1);
    this.logKey = this.logKey + 1;
    this.$emit("change", true);
  }

  /** watch state and update the variable */
  @Watch("appData")
  onDataChanged(value: any, oldValue: any) {
    if (!this.appData.logframework) {
      this.appData.logframework = [];
    }
  }
}
